import React from 'react';
import { Link } from 'react-router-dom';
import { FiClock, FiArrowRight } from 'react-icons/fi';

const BlogCard = ({ post }) => {
  return (
    <Link 
      to={`/insights/${post.slug}`}
      className="block h-full"
    >
      <article className="card blog-card-hover h-full flex flex-col p-8 relative overflow-hidden group">
        {/* Status Badge */}
        <div className="absolute top-4 right-4">
          <span className="bg-gold/20 text-navy px-3 py-1 rounded-full text-xs font-medium">
            {post.status}
          </span>
        </div>

        {/* Category */}
        <p className="text-sm text-gold font-medium mb-3">
          {post.category}
        </p>

        {/* Title */}
        <h3 className="text-2xl font-serif text-navy mb-4 group-hover:text-gold transition-colors">
          {post.title}
        </h3>

        {/* Preview */}
        <p className="text-charcoal mb-6 flex-grow leading-relaxed">
          {post.preview}
        </p>

        {/* Meta */}
        <div className="flex items-center justify-between text-sm text-gray-600">
          <div className="flex items-center space-x-4">
            <span>{post.date}</span>
            <span className="flex items-center">
              <FiClock className="mr-1" size={14} />
              {post.readTime} min
            </span>
          </div>
          
          <FiArrowRight 
            className="text-gold group-hover:translate-x-2 transition-transform" 
            size={18} 
          />
        </div>

        {/* Hover Effect Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-gold/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
      </article>
    </Link>
  );
};

export default BlogCard;